export const formatRs = (amount, decimals = 2) => {
  if (amount === null || amount === undefined || amount === '') return '—';
  const num = parseFloat(amount);
  if (isNaN(num)) return '—';
  return `Rs. ${num.toLocaleString('en-LK', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })}`;
};

export const formatRsShort = (amount) => {
  if (!amount) return '—';
  const num = parseFloat(amount);
  if (isNaN(num)) return '—';
  if (num >= 1000000) return `Rs. ${(num/1000000).toFixed(1)}M`;
  if (num >= 1000)    return `Rs. ${(num/1000).toFixed(0)}K`;
  return `Rs. ${num.toFixed(0)}`;
};
